<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof47-1">
<p class="para2"><em class="italic">Motto:</em> “For Faith and Fidelity” (<em class="italic">Za veru i vernost</em>)</p>
<p class="para"><em class="italic">Color of the Ribbon:</em> Blue</p>
<p class="centerImage"><img alt="image" id="imgfr30" src="images/imgfr30.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. Andrew with the Grand Cross on Parade Uniform</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof471.vue?375bcc0a